import { CourseFormComparisonDto } from './dtos';

/** A course can compare two fragments once; direction remains a property of that comparison. */
export function comparisonPairKey(earlier: string, later: string): string | null {
    return earlier && later ? JSON.stringify([earlier, later].sort()) : null;
}

export function hasDuplicateComparisonPairs(comparisons: CourseFormComparisonDto[]): boolean {
    const seen = new Set<string>();
    for (const comparison of comparisons) {
        const pair = comparisonPairKey(comparison.earlier_fragment_key, comparison.later_fragment_key);
        if (pair === null) continue;
        if (seen.has(pair)) return true;
        seen.add(pair);
    }
    return false;
}
